import React, { FormEvent, useEffect, useState } from "react";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Toaster } from "react-hot-toast";
import { useHistory } from "react-router-dom";
import Input from "../../../../components/Input";
import Spinner from "../../../../components/Spinner";
import { toastError, toastSuccess } from "../../../../components/Toast";
import useAuthData from "../../../../hook/useAppData";
import { remask, unRemask } from "../../../../libs/remask-mask";
import { SwitchBlue } from "../../../../libs/switch";
import { deleteImageClient, getClientById, postClient, putClient } from "../../service";
import { initialValues } from "./constants";
import { IFieldValues } from "./model";
import { IconLeftArrowVersion2 } from "../../../../icons";
import "./index.scss";
import { UploadImage } from "../../../../components/CropperImage";
import Button from "../../../../components/Button";

export interface IFile {
  fieldname: string;
  originalname: string;
  encoding: string;
  mimeType: string;
  buffer: any;
  size: number;
}

export function FormClientPage(props) {
  const { token } = useAuthData();
  const [fieldValues, setFieldValues] = useState<IFieldValues>(initialValues as any);
  const [postOrUpdate, setPostOrUpdate] = useState<"post" | "update">("post");
  const [needSpinner, setNeedSpinner] = useState(true);
  const [image, setImage] = useState<IFile>();

  const params = props?.match?.params?.id;
  const history = useHistory();

  useEffect(() => {
    if (params) {
      setPostOrUpdate("update");
      clientById();
    } else setNeedSpinner(false);
  }, []);

  useEffect(() => {
    if (postOrUpdate === "update") {
      setNeedSpinner(false);
    }
  }, [fieldValues]);

  async function clientById() {
    const res = await getClientById(token, params);
    setFieldValues(res);
  }

  function setValueOfField(event: { name: string; value: any }) {
    const { name, value } = event;
    setFieldValues({ ...fieldValues, [`${name}`]: value });
  }

  function handleSubmitForm(event: FormEvent) {
    event.preventDefault();
    if (verefyIfDontHaveError()) return;
    verefyIfFieldIsNotEmpty();
  }

  function verefyIfFieldIsNotEmpty() {
    let obj = {};
    for (let keyField in fieldValues) {
      obj = removeMaskKeyField(keyField, obj);
    }
    postOrUpdateService(obj);
  }

  function removeMaskKeyField(keyField: string, obj) {
    const keyIsPhoneOrCnpj = () => keyField === "phone" || keyField === "cnpj";

    if (keyIsPhoneOrCnpj()) return { ...obj, [`${keyField}`]: unRemask(fieldValues[keyField]) };
    return { ...obj, [`${keyField}`]: fieldValues[keyField] };
  }

  function verefyIfDontHaveError() {
    const nameClientIsEmpty = !fieldValues?.name?.replaceAll(" ", "");
    if (nameClientIsEmpty) {
      toastError(`Nome da empresa não pode ser vazio`);
      return true;
    }
    return false;
  }

  function postOrUpdateService(data) {
    if (postOrUpdate === "post") return addClient(data);
    return updateClient(data);
  }

  async function addClient(data) {
    const res = await postClient(token, { body: data, file: image });
    verefyRes(res);
  }

  async function updateClient(data) {
    const res = await putClient(token, { body: data, file: image }, params);
    verefyRes(res);
  }

  async function verefyRes(res: any) {
    if (!res?.ok) return toastError("Não foi possivel concluir a ação, verifique e tente novamente!");
    toastSuccess("Ação concluida com sucesso!");
    return setTimeout(() => {
      handleClickExit();
    }, 2 * 1000);
  }

  function handleClickExit() {
    return history.push("/clients");
  }

  async function handleDeleteImage() {
    const responseOfDeleteClick = await deleteImageClient(token, params);
    if (responseOfDeleteClick?.status) return toastSuccess("Imagem removida com sucesso!");
    return toastError("Não foi possível remover a imagem, tente novamente mais tarde!");
  }

  return (
    <>
      <Toaster />
      <Spinner status={needSpinner}>
        <div className="form-clients">
          <div className="header-clients">
            <h1 className="title-clients">
              <span className="arrow-exit-clients" onClick={handleClickExit}>
                {IconLeftArrowVersion2}
              </span>{" "}
              Clientes - {postOrUpdate === "post" ? "Adicionar novo" : "Atualizar"} cliente {fieldValues?.name ? "- " + fieldValues?.name : ""}
            </h1>
          </div>
          <form onSubmit={handleSubmitForm} className="box-form-clients">
            <div className="box-row m-top10 md:flex-wrap">
              <Input
                className="input-client justify-center "
                name="name"
                label="Nome da empresa"
                placeholder="Nome da empresa"
                value={fieldValues?.name}
                setValue={(e) => setValueOfField(e.target)}
                required={true}
                autofocus={true}
              />
              <Input
                className="input-client justify-center"
                name="cnpj"
                label="CNPJ"
                placeholder="00.000.000/0000-00"
                value={fieldValues?.cnpj ? remask(fieldValues?.cnpj, ["99.999.999/9999-99"]) : fieldValues?.cnpj}
                setValue={(e) => setValueOfField(e.target)}
              />
              <UploadImage img={fieldValues?.img} setImage={setImage} className="image-client-form" handleDeleteImage={handleDeleteImage} />
            </div>
            <div className="box-row">
              <Input
                name="stateRegistration"
                label="Inscrição Estadual"
                placeholder="000.000.000.000"
                value={fieldValues?.stateRegistration}
                setValue={(e) => setValueOfField(e.target)}
              />

              <Input
                name="phone"
                label="Telefone de Contato"
                placeholder="(00) 00000-0000"
                value={
                  fieldValues?.phone
                    ? remask(fieldValues?.phone, unRemask(fieldValues?.phone).length < 11 ? ["(99) 9999-9999"] : ["(99) 9 9999-9999"])
                    : fieldValues?.phone
                }
                setValue={(e) => setValueOfField(e.target)}
              />
              <Input
                name="email"
                label="E-mail de contato"
                placeholder="email@email.com.br"
                value={fieldValues?.email}
                setValue={(e) => setValueOfField(e.target)}
                type="email"
              />
            </div>
            <div className="box-row">
              <Input
                name="street"
                label="Rua"
                placeholder="Nome da rua"
                value={fieldValues?.street}
                setValue={(e) => setValueOfField(e.target)}
                className=""
              />
              <Input
                name="district"
                label="Bairro"
                placeholder="Bairro"
                value={fieldValues?.district}
                setValue={(e) => setValueOfField(e.target)}
                className=""
              />
              <Input
                name="number"
                label="Número"
                placeholder="00000"
                value={fieldValues?.number}
                setValue={(e) => setValueOfField(e.target)}
                className="max-width-10p100"
              />
            </div>
            <div className="box-row">
              <Input
                name="complement"
                label="Complemento"
                placeholder="Complemento"
                value={fieldValues?.complement}
                setValue={(e) => setValueOfField(e.target)}
                className=""
              />
              <Input
                name="city"
                label="Cidade"
                placeholder="Cidade"
                value={fieldValues?.city}
                setValue={(e) => setValueOfField(e.target)}
                className=""
              />
              <Input
                name="state"
                label="Estado"
                placeholder="AA"
                value={fieldValues?.state ? remask(fieldValues?.state.toUpperCase(), ["AA"]) : fieldValues?.state}
                setValue={(e) => setValueOfField(e.target)}
                className="max-width-10p100"
              />
            </div>

            <div className="box-row justify-between">
              <div className="box-row p-4 pl-2">
                <Button className="btn bg-primary" type="submit">
                  Salvar
                </Button>
                <Button className="btn bg-secondary" type="button" onClick={handleClickExit}>
                  Cancelar
                </Button>
              </div>
              {postOrUpdate === "update" && (
                <div className="box-switch-clients">
                  <FormControlLabel
                    className="w-full justify-end"
                    label={`Estado do Cliente ${fieldValues?.name ? "- " + fieldValues?.name : ""}`}
                    labelPlacement="start"
                    control={
                      <SwitchBlue
                        className="mt-2"
                        checked={!fieldValues?.isDeleted}
                        onChange={() => setFieldValues({ ...fieldValues, isDeleted: !fieldValues?.isDeleted })}
                        name="checkedB"
                        color="primary"
                      />
                    }
                  />
                </div>
              )}
            </div>
          </form>
        </div>
      </Spinner>
    </>
  );
}
